
import React from 'react';

export default class ZTermsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return (
			<div className="AMCStaticPage">
			<div className="AMCStaticPageContent">
			<h1>Terms</h1>
<div className="AMCStaticSection"><p><strong>Short and sweet:</strong> No hate. Nothing illegal. Nothing unethical. And we reserve the right to decide what these terms mean and the right to remove content and users at our sole discretion.</p></div>
<div className="AMCStaticSection"><p>
      These Terms and Conditions (the "
      <strong>Terms and Conditions</strong>
      "), and any other terms or agreements incorporated herein by reference,
      between you and Automatic.ai, Inc. and any of our affiliated companies ("
      <strong>Automatic.ai</strong>
      ") govern your access to, use of, and participation in any Automatic.ai
      website, product or service and the services described in the
      <a href="/-/devterms">
        Automatic.ai Developer and API License Agreement
      </a>
      , applications or software, including the Automatic.ai API (collectively,
      the "
      <strong>Services</strong>
      "). These Terms and Conditions do not change the terms or conditions of
      any other written agreement you may have with Automatic.ai. If you are
      using the Services on behalf of an entity, you represent and warrant
      that you are authorized to accept these Terms and Conditions on the
      entity's behalf and that the entity agrees to be responsible to
      Automatic.ai if you violate these Terms and Conditions.
    </p></div> <div className="AMCStaticSection"><h4>THE SERVICES</h4> <p>
      The Automatic.ai Services provide a platform for the use, development,
      and commercialization of algorithms as well as for the automation of
      developer operations for Machine Learning and Deep Learning models. Your
      right to access and use the Services is contingent upon your access and
      use of the Services in accordance with these Terms and Conditions.
    </p></div> <div className="AMCStaticSection"><h4>
      ACCEPTANCE AND CHANGES TO THESE TERMS AND CONDITIONS
    </h4> <p>
      THESE TERMS AND CONDITIONS CONSTITUTE AN ENFORCEABLE LEGAL AGREEMENT
      BETWEEN YOU AND AUTOMATIC.AI. PLEASE READ THEM CAREFULLY. BEFORE YOU MAY
      ACCESS OR USE THE SERVICES, YOU MUST AGREE TO BE BOUND BY THESE TERMS
      AND CONDITIONS. IF YOU DO NOT AGREE TO THE TERMS, CONDITIONS AND
      RESTRICTIONS SET FORTH IN THESE TERMS AND CONDITIONS, AUTOMATIC.AI DOES
      NOT GRANT YOU THE RIGHT TO USE THE SERVICES.
    </p> <p>
      Automatic.ai reserves the right at any time to modify these Terms and
      Conditions and to impose new or additional terms or conditions on your
      use of the Services. Automatic.ai will notify you of the modifications
      and/or new or additional terms or conditions by revising the date at the
      top of the Terms and Conditions and, in some cases, may provide you with
      additional notice (such as adding a statement to the Automatic.ai
      homepage or sending you an email notification). Such modifications
      and/or additional terms and conditions will become effective at the end
      of the 30 day period beginning when Automatic.ai posts the changes via
      the Services (
      <strong>"Notice Period"</strong>
      ). If you disagree with any changes, you must stop using the Services
      within the Notice Period. Your continued use of the Services after the
      Notice Period will be deemed acceptance of the changes. You should
      review these Terms and Conditions whenever you access the Services and
      at least every 30 days to make sure that you understand the terms,
      conditions, and restrictions that will apply to your use of the
      Services.
    </p> <p>
      Notwithstanding any other provision of these Terms and Conditions,
      Automatic.ai reserves the right to change, suspend, remove, or disable
      access to the Services or any content or other materials comprising a
      part of the Services at any time without notice. In no event will
      Automatic.ai be liable for making these changes. Automatic.ai may also
      impose limits on the use of or access to certain features or portions of
      the Services, in any case and without notice or liability.
    </p> <p>
      Additional terms and conditions may apply to certain Services. When you
      use a Service offered by Automatic.ai, you will also be subject to the
      guidelines, terms and agreements applicable to that particular Service
      (the "
      <strong>Service Terms</strong>
      "). In the event of any conflict between these Terms and Conditions and
      any particular Service Terms, the Service Terms will control.
    </p></div> <div className="AMCStaticSection"><h4>REQUIREMENTS FOR USE OF THE SERVICES</h4> <p>
      No individual under the age of 13 may use the Services, provide any
      personal information to Automatic.ai, or otherwise submit personal
      information through the Services. If you are 13 or older, but under the
      age of 18, your parent or guardian must agree to be bound by these Terms
      and Conditions and you may only use the Services with your parent or
      guardian's consent or under your parent or guardian's supervision.
    </p> <p>
      Use of the Services requires Internet access, compatible hardware, and
      may also require periodic updates to your browser, hardware, and/or
      other software. You agree that meeting these requirements, which may
      also change from time to time, is your responsibility.
    </p></div> <div className="AMCStaticSection"><h4>YOUR ACCOUNT</h4> <p>
      Certain aspects of the Services require registration. As a registered
      user of the Services, you will establish an account ("
      <strong>Account</strong>
      "). You may not reveal your Account information to anyone else. You are
      solely responsible for maintaining the confidentiality and security of
      your Account, and for all activities that occur on or through your
      Account, and you agree to immediately notify Automatic.ai of any security
      breach of your Account. You accept all risks of unauthorized access and
      use relating to your use of the Services. Automatic.ai reserves the right
      to deny, deactivate, or terminate your Account for any reason at
      Automatic.ai's discretion and Automatic.ai shall not be responsible for
      any losses arising out of the unauthorized use of your Account. You may
      not assign or otherwise transfer your Account to any other person or
      entity.
    </p> <p>
      You agree to provide accurate and complete information when you register
      with, and as you use, the Services ("
      <strong>Registration Data</strong>
      "), and you agree to update your Registration Data to keep it accurate
      and complete. You agree that Automatic.ai may store and use the
      Registration Data you provide for use in maintaining and billing fees to
      your Account.
    </p></div> <div className="AMCStaticSection"><h4>SPECIAL PROVISION FOR DEVELOPERS</h4> <p>
      If you develop algorithms, software or services based on or for the
      Services and would like to deploy algorithms and/or other software ("
      <strong>Software</strong>
      ") for the Automatic.ai API, Automatic.ai.com, and/or other Automatic.ai
      products, services, applications or software, you must agree to and
      comply with the
      <a href="/api_dev_terms">
        Automatic.ai Developer and API License Agreement
      </a>
      . The Automatic.ai Developer and API License Agreement is incorporated
      into these Terms and Conditions by reference.
    </p></div> <div className="AMCStaticSection"><h4>PRIVACY</h4> <p>
      Please see
      <a href="/-/privacy">Automatic.ai's Privacy Policy</a>
      , for information regarding how Automatic.ai collects, uses, and
      discloses information about users of the Services. The Services are
      subject to Automatic.ai's Privacy Policy and by using the Services, you
      consent to the collection, use and sharing (as set forth in
      Automatic.ai's Privacy Policy) of your information, including the
      transfer of this information to the United States and/or other countries
      for storage, processing and use by Automatic.ai.
    </p></div> <div className="AMCStaticSection"><h4>COMMUNICATION PREFERENCES</h4> <p>
      By using the Services, you consent to receiving electronic
      communications from Automatic.ai relating to your Account, including
      email communications and/or notifications within the Services. You agree
      that any notice, agreements, disclosure or other communications that we
      send to you electronically will satisfy any legal communication
      requirements, including that such communications be in writing. You also
      consent to receiving certain other communications from us, including
      information about Automatic.ai features, updates, special offers,
      promotions, and surveys. If you no longer wish to receive these
      communications, you may opt out by following the opt out instructions
      provided on your account page located at
      <a href="/account">https://automatic.ai/account</a>
      .
    </p></div> <div className="AMCStaticSection"><h4>LIMITED LICENSE</h4> <p>
      Subject to your compliance with these Terms and Conditions, Automatic.ai
      hereby grants to you a personal, non-exclusive, non-transferable,
      non-sublicensable, revocable license to access the Services for the sole
      purpose of enabling you to use the Services in the manner permitted by
      these Terms and Conditions. In the event that Automatic.ai, in its sole
      discretion, elects to provide any upgrades that replace or supplement
      the original Services, this license will govern any such upgrades unless
      any such upgrade is accompanied by a separate license, in which case the
      terms of the separate license will govern.
    </p></div> <div className="AMCStaticSection"><h4>COMPLIANCE</h4> <p>
      Automatic.ai provides users with the ability to communicate with each
      other within the Services, such as by using the discussion feature that
      is available for algorithms ("
      <strong>Communication Services</strong>
      "). By way of example, and not as a limitation, you agree that when
      using a Communication Service, you will not: defame, abuse, harass,
      stalk, threaten or otherwise violate the legal rights (such as rights of
      privacy and publicity) of others; publish, post, upload, distribute or
      disseminate any inappropriate, profane, defamatory, infringing, obscene,
      indecent or unlawful topic, name, material or information; upload files
      that contain software or other material protected by intellectual
      property laws (or by rights of privacy of publicity) unless you own or
      control the rights thereto or have received all necessary consents;
      upload files that contain viruses, corrupted files, or any other similar
      software or programs that may damage the operation of another's
      computer; advertise or offer to sell or buy any goods or services for
      any business purpose, unless such Communication Service expressly
      permits such messages; conduct or forward surveys, contests, pyramid
      schemes or chain letters; download any file posted by another user of a
      Communication Service that you know, or reasonably should know, cannot
      be legally distributed in such manner; falsify or delete any author
      attributions, legal or other proper notices or proprietary designations
      or labels of the origin or source of software or other material
      contained in a file that is uploaded, restrict or inhibit any other user
      from using and enjoying the Communication Services; violate any code of
      conduct or other guidelines which may be applicable for any particular
      Communication Service; harvest or otherwise collect information about
      others, including e-mail addresses, without their consent; violate any
      Applicable Laws or regulations.
    </p></div> <div className="AMCStaticSection"><h4>USE OF APPLICATION</h4> <p>
      You agree not to violate, circumvent, reverse-engineer, decompile,
      disassemble, or otherwise tamper with any security technology related to
      the Application for any reason-or to attempt or assist another person to do
      so. You agree not to access the Application by any means other than through
      software or APIs that are provided by Automatic.ai for accessing the
      Application. You shall not access or attempt to access an Account that you
      are not authorized to access. Violations of system or network security
      may result in civil or criminal liability.
    </p> <p>
      You acknowledge that, because some aspects of the Services entail the
      ongoing involvement of Automatic.ai, if Automatic.ai changes any part of
      or discontinues the Services, which Automatic.ai may do at its election,
      you may not be able to use the Services to the same extent as prior to
      such change or discontinuation, and that Automatic.ai shall have no
      liability to you in such case.
    </p></div> <div className="AMCStaticSection"><h4>RESTRICTIONS</h4> <p>
      You are solely responsible for your conduct (and the conduct of anyone
      who uses the Services on your behalf) with respect to the Service, which
      you use at your own risk. Except as expressly permitted in writing by
      Automatic.ai, you will not do, and will not permit any third party to do,
      any of the following:
    </p> <ol type="i" className="syn-mb-16"><li>copy, adapt, hack, of reproduce the Services;</li>
	 <li>rent, lease, lend, sell, transfer or sublicense the Services;</li> <li>
        modify, port, translate, or create derivative works of the Services;
      </li> <li>
        remove, alter, or obscure any copyright, trademark, or other
        proprietary rights notice or labels on or in the Services;
      </li> <li>
        knowingly take any action that would cause the Services or any part
        the Services to be placed in the public domain;
      </li> <li>
        use the Services in any manner that could interfere with, disrupt,
        negatively affect, or inhibit Automatic.ai's other users from fully
        enjoying the Services or that could damage, disable, overburden, or
        impair the functioning of the Services;
      </li> <li>
        stalk, intimidate, threaten, harass, or cause discomfort to other
        users of the Services;
      </li> <li>
        harvest or collect information about other users of the Services
        without their consent;
      </li> <li>
        impersonate or use the Services on behalf of any person or entity or
        otherwise misrepresent your affiliation with a person or entity;
      </li> <li>
        use the Services for any illegal or unauthorized purpose or engage in,
        encourage, or promote any illegal activity, or any activity that
        violates these Terms and Conditions; or
      </li> <li>infringe or violate any of Automatic.ai's rights.</li></ol> <p>
      If you violate (or are alleged to have violated) any of the foregoing
      restrictions, your right to use of the Services will immediately and
      automatically terminate, and you may have infringed the copyright or
      other rights of Automatic.ai, which may subject you to prosecution and
      damages.
    </p></div> <div className="AMCStaticSection"><h4>YOUR API KEY</h4> <p>
      In order to use the Automatic.ai API, you must obtain appropriate API
      credentials (an "
      <strong>API Key</strong>
      ") via registration on Automatic.ai.com. You may not reveal your API Key
      to anyone else and must keep your API Key secure. You are solely
      responsible for maintaining the confidentiality and security of your API
      Key, and for all activities that occur through the use of your API Key.
      You agree to immediately notify Automatic.ai of any security breach of
      your API Key. You accept all risks of unauthorized use of your API Key.
      Automatic.ai reserves the right to deny, deactivate, or terminate your
      API Key for any reason at Automatic.ai's discretion and Automatic.ai shall
      not be responsible for any losses arising out of the unauthorized use of
      your API Key.
    </p></div> <div className="AMCStaticSection"><h4>SECURITY</h4> <p>
      You may not use your API Key or the Services to test or undermine the
      security of the Services. You will not and will not attempt to (i)
      interfere with, modify or disable any features, functionality or
      security controls of the Services or Automatic.ai API, (ii) defeat,
      avoid, bypass, remove, deactivate or otherwise circumvent any protection
      mechanisms incorporated into the Service, or (iii) reverse engineer,
      decompile, disassemble or derive source code, underlying ideas,
      algorithms, structure or organizational form from the Services or
      Automatic.ai API.
    </p> <p>
      You are solely responsible for your conduct (and the conduct of anyone
      who uses your API Key to access the Services). You will comply with any
      limitations imposed by Automatic.ai on the frequency of access and calls
      to and use of the Automatic.ai API and/or any additional programmatic
      limitations on the Automatic.ai API.
    </p> <p>
      You will immediately report to Automatic.ai any security flaws you
      discover in any of the Services. Automatic.ai reserves the right, in its
      sole discretion, to determine what constitutes a security flaw. Failure
      to report such flaws, particularly prior to public disclosure, shall be
      considered a material breach of this Agreement.
    </p></div> <div className="AMCStaticSection"><h4>MALWARE AND SPAM</h4> <p>
      You will not publish or link to malicious content or code intended to
      damage, disrupt, compromise, or exploit a user's browser, device,
      Automatic.ai account, or API Key or to compromise an individual's privacy
      in any manner. You will not use the Services or Automatic.ai API, and
      won't create Software, for the purpose of sending spam or distributing
      malware. Automatic.ai reserves the right, in its sole discretion, to
      determine what constitutes spam and/or malware.
    </p></div> <div className="AMCStaticSection"><h4>MONITORING</h4> <p>
      Automatic.ai has the right, but not the obligation, to monitor your use
      of the Services and Automatic.ai API for any reason or no reason,
      including to ensure your compliance with these Terms and Conditions.
    </p></div> <div className="AMCStaticSection"><h4>SUBMISSIONS TO THE SERVICES</h4> <p>
      The Services may offer interactive features that allow you to submit
      materials (including links to third-party content and source code) on
      areas of the Services accessible and viewable by other users of the
      Services and the public. You agree that any use by you of such features,
      including any materials submitted by you, shall be your sole
      responsibility, shall not infringe or violate the rights of any other
      party or violate any laws, contribute to or encourage infringing or
      otherwise unlawful conduct, or otherwise be obscene, objectionable, or
      in poor taste. You represent and warrant that you own or have obtained
      all necessary rights and licenses to any materials submitted by you. You
      agree to provide accurate and complete information in connection with
      your submission of any materials on the Services. You do not transfer
      ownership of any such materials to Automatic.ai, but you do hereby grant
      Automatic.ai, in its capacity as the provider of the Services, a
      worldwide, non-exclusive, perpetual, irrevocable, royalty-free license
      to use such materials in connection with the Services; provided,
      however, that if such materials include any FOSS, in the event of a
      conflict between the applicable FOSS license terms and the license terms
      set forth in this paragraph, the applicable FOSS license terms will
      control, but only to the extent required by the FOSS that you use. For
      purposes of these Terms and Conditions, "
      <strong>FOSS</strong>
      " means any software licensed under an Open Source Initiative Approved
      License, a list of which is currently available at
      <a href="http://opensource.org/licenses/alphabetical">
        http://opensource.org/licenses/alphabetical
      </a>
      . Automatic.ai reserves the right to not post or publish any materials,
      and to remove or edit any material, at any time in its sole discretion
      without notice or liability.
    </p> <p><strong>Repeat Infringer Policy.</strong>
      In accordance with the Digital Millennium Copyright Act (DMCA) and other
      Applicable Law, Automatic.ai has adopted a policy of terminating, in
      appropriate circumstances and at Automatic.ai 's discretion, users who
      are deemed to be repeat infringers. Automatic.ai also may, at its
      discretion, limit access to the Services and terminate access of any
      users who infringe any intellectual property rights of others, whether
      or not there is any repeat infringement.
    </p> <p><strong>Copyright Complaints.</strong>
      If you believe that anything on the Services infringes upon any
      copyright that you own or control, you may file a notification with
      Automatic.ai 's Designated Agent as set forth below:
    </p> <
		div className="syn-row"><div className="syn-col syn-col-sm-6"><p>Designated agent:</p></div> <div className="syn-col syn-col-sm-6"><p>Michael Davis</p></div></div> 
		<div className="syn-row"><div className="syn-col syn-col-sm-6"><p>Address of designated agent:</p></div> <div className="syn-col syn-col-sm-6"><p>3301 Kenneth Drive, Palo Alto, CA 94303</p></div></div> 
		<div className="syn-row"><div className="syn-col syn-col-sm-6"><p>Email Address of Designated Agent:</p></div> <div className="syn-col syn-col-sm-6"><p>copyright@automatic.ai</p></div></div> <br/> <p>
      Please see
      <a href="http://www.gpo.gov/fdsys/pkg/USCODE-2011-title17/pdf/USCODE-2011-title17-chap5-sec512.pdf">
        17 U.S.C. sec. 512(c)(3)
      </a>
      for the requirements of a proper notification. If you knowingly
      misrepresent in your notification that the material or activity is
      infringing, you may be liable for any damages, including costs and
      attorneys' fees, incurred by Automatic.ai or the alleged infringer as the
      result of Automatic.ai relying upon such misrepresentation in removing or
      disabling access to the material or activity claimed to be infringing.
    </p> <p>
      Automatic.ai has the right, but not the obligation, to monitor any
      materials submitted by you or otherwise available on the Services, to
      investigate any reported or apparent violation of these Terms and
      Conditions, and to take any action that Automatic.ai in its sole
      discretion deems appropriate, including termination hereunder.
    </p></div> <div className="AMCStaticSection"><h4>THIRD-PARTY MATERIALS</h4> <p>
      Certain content and services available via the Services may include
      materials from third parties. Automatic.ai may provide links to
      third-party websites as a convenience to you. You agree that Automatic.ai
      is not responsible for examining or evaluating the content or accuracy
      and Automatic.ai does not warrant and will not have any liability or
      responsibility for any third-party materials or websites, or for any
      other materials, products, or services of third parties. You agree that
      you will not use any third-party materials in a manner that would
      infringe or violate the rights of any other party and that Automatic.ai
      is not in any way responsible for any such use by you.
    </p></div> <div className="AMCStaticSection"><h4>OBJECTIONABLE MATERIAL</h4> <p>
      You understand that by using the Services, you may encounter material
      that you may deem to be offensive, indecent, or objectionable, and that
      such content may or may not be identified as having explicit material.
      Nevertheless, you agree to use the Services at your sole risk and
      Automatic.ai shall have no liability to you for material that may be
      found to be offensive, indecent, or objectionable.
    </p></div> <div className="AMCStaticSection"><h4>INTELLECTUAL PROPERTY</h4> <p>
      You agree that the Services, including text, graphics, logos, user
      interface, and the scripts and software used to implement the Services,
      contain proprietary information and material that is owned by
      Automatic.ai, and is protected by applicable intellectual property and
      other laws, including copyright. You agree that you will not use such
      proprietary information or materials in any way whatsoever except for
      use of the Services in compliance with these Terms and Conditions. No
      portion of the Services may be copied or reproduced in any form or by
      any means, except as expressly permitted in these Terms and Conditions.
      You agree not to rent, lease, loan, license, sell, distribute, modify or
      create derivative works based on the Services in any manner, and you
      shall not exploit the Services in any unauthorized way whatsoever,
      including by trespass or burdening network capacity.
    </p> <p>
      All copyrights in and to the Services (including the compilation of
      content, postings, links to other Internet resources, and descriptions
      of those resources) and related software are owned by Automatic.ai, who
      reserve all their rights in law and equity. THE USE OF SOFTWARE, THE
      AUTOMATIC.AI API OR ANY PART OF THE SERVICES, OTHER THAN IN ACCORDANCE
      WITH THESE TERMS AND CONDITIONS, IS STRICTLY PROHIBITED AND MAY INFRINGE
      THE INTELLECTUAL PROPERTY RIGHTS OF AUTOMATIC.AI OR OTHER THIRD PARTIES,
      WHICH MAY SUBJECT YOU TO CIVIL AND CRIMINAL PENALTIES, INCLUDING
      POSSIBLE MONETARY DAMAGES.
    </p> <p>
      Automatic.ai, the Automatic.ai logo, and any other Automatic.ai trademarks,
      service marks, graphics, and logos used in connection with the Services
      are trademarks or registered trademarks of Automatic.ai Inc. The look and
      feel of the Services, including all custom graphics, button icons, and
      scripts constitute service marks, trademarks, or trade dress of
      Automatic.ai and may not be copied, imitated, or used (in whole or in
      part) without Automatic.ai's prior written consent. All other trademarks,
      service marks, graphics, and logos used in connection with the Services
      ("
      <strong>Third Party Trademarks</strong>
      ") are the property of their respective owners and the use of such Third
      Party Trademarks inures to the benefit of each owner. You are granted no
      right or license with respect to any of the aforesaid trademarks and any
      use of such trademarks.
    </p> <p>
      Any suggestions, comments, or other feedback (collectively, "
      <strong>Feedback</strong>
      ") that you provide regarding Automatic.ai or the Services will
      constitute Automatic.ai's confidential information. Automatic.ai is free
      to use, disclose, reproduce, license, distribute, and exploit this
      Feedback as Automatic.ai sees fit without obligation or restriction of
      any kind.
    </p></div> <div className="AMCStaticSection"><h4>TERMINATION</h4> <p>
      If you fail, or Automatic.ai suspects that you have failed, to comply
      with any of the provisions of these Terms and Conditions, Automatic.ai,
      at its sole discretion, without notice to you may: (i) immediately
      terminate your right to access and use the Services and/or your Account,
      and you will remain liable for all amounts due under your Account up to
      and including the date of termination; and/or (ii) preclude access to
      the Services (or any part thereof).
    </p></div> <div className="AMCStaticSection"><h4>
      DISCLAIMER OF WARRANTIES; LIMITATIONS OF LIABILITY
    </h4> <p>
      AUTOMATIC.AI DOES NOT GUARANTEE, REPRESENT, OR WARRANT THAT YOUR USE OF
      THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, AND YOU AGREE THAT
      FROM TIME TO TIME AUTOMATIC.AI MAY REMOVE THE SERVICES FOR INDEFINITE
      PERIODS OF TIME, OR CANCEL THE SERVICES AT ANY TIME, WITHOUT NOTICE TO
      YOU.
    </p> <p>
      YOU EXPRESSLY AGREE THAT YOUR USE OF, OR INABILITY TO USE, THE SERVICES
      IS AT YOUR SOLE RISK. THE SERVICES AND ALL PRODUCTS AND SERVICES
      DELIVERED TO YOU THROUGH THE SERVICES ARE PROVIDED ON AN &quot;
      <strong>AS IS</strong>
      &quot; AND &quot;
      <strong>AS AVAILABLE</strong>
      &quot; BASIS. AUTOMATIC.AI DISCLAIMS ALL REPRESENTATIONS AND WARRANTIES OF ANY
      KIND, EITHER EXPRESS OR IMPLIED OR ORAL OR WRITTEN, INCLUDING ALL
      IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
      TITLE, AND NONINFRINGEMENT WITH RESPECT TO THESE TERMS AND CONDITIONS
      AND THE SERVICES, WHETHER ALLEGED TO ARISE BY OPERATION OF LAW, BY
      REASON OF CUSTOM OR USAGE IN THE TRADE, BY COURSE OF DEALING OR
      OTHERWISE. BECAUSE SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF
      IMPLIED WARRANTIES, THE ABOVE EXCLUSION OF IMPLIED WARRANTIES MAY NOT
      APPLY TO YOU.
    </p> <p>
      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAWS, AUTOMATIC.AI DOES NOT
      WARRANT, AND DISCLAIMS ALL LIABILITY FOR (A) THE COMPLETENESS, ACCURACY,
      AVAILABILITY, TIMELINESS, SECURITY OR RELIABILITY OF THE SERVICES; (B)
      ANY HARM TO YOUR COMPUTER SYSTEM, LOSS OF DATA, CORRUPTION, ATTACK,
      VIRUSES, INTERFERENCE, HACKING, OR OTHER SECURITY INTRUSION OR OTHER
      HARM THAT RESULTS FROM YOUR ACCESS TO OR USE OF THE SERVICES, OR ANY
      USER CONTENT; (C) THE DELETION OF, OR THE FAILURE TO STORE OR TO
      TRANSMIT, ANY USER CONTENT AND OTHER COMMUNICATIONS MAINTAINED BY THE
      SERVICES; AND (D) WHETHER THE SERVICES WILL MEET YOUR REQUIREMENTS OR BE
      AVAILABLE ON AN UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS. NO ADVICE OR
      INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM ALGORTIHMIA OR
      THROUGH THE SERVICES, WILL CREATE ANY WARRANTY NOT EXPRESSLY MADE IN
      THESE TERMS AND CONDITIONS. YOU SHALL BE RESPONSIBLE FOR BACKING UP YOUR
      OWN SYSTEM.
    </p> <p>
      TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEITHER AUTOMATIC.AI,
      NOR ANY OF ITS DIRECTORS, OFFICERS, EMPLOYEES, AFFILIATES, AGENTS,
      CONTRACTORS, PRINCIPALS, OR LICENSORS, SHALL BE LIABLE TO YOU OR ANY
      THIRD PARTY FOR ANY INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL, OR
      CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF ANY OF THE SERVICES OR
      FOR ANY OTHER CLAIM RELATED IN ANY WAY TO YOUR USE OF THE SERVICES,
      INCLUDING ANY ERRORS OR OMISSIONS IN ANY CONTENT, OR ANY LOSS OR DAMAGE
      OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT (OR PRODUCT)
      POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SERVICES,
      HOWEVER CAUSED, REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT,
      WARRANTY, TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR
      IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY), EVEN IF
      ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL THE
      AGGREGATE LIABILITY OF AUTOMATIC.AI EXCEED FIVE HUNDRED U.S. DOLLARS
      (U.S. $500). BECAUSE SOME STATES OR JURISDICTIONS DO NOT ALLOW THE
      EXCLUSION OR THE LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL
      DAMAGES, IN SUCH STATES OR JURISDICTIONS, AUTOMATIC.AI'S LIABILITY SHALL
      BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.
    </p> <p>
      AUTOMATIC.AI SHALL USE REASONABLE EFFORTS TO PROTECT INFORMATION
      SUBMITTED BY YOU IN CONNECTION WITH THE SERVICES, BUT YOU AGREE THAT
      YOUR SUBMISSION OF SUCH INFORMATION IS AT YOUR SOLE RISK, AND
      AUTOMATIC.AI HEREBY DISCLAIMS ANY AND ALL LIABILITY TO YOU FOR ANY LOSS
      OR LIABILITY RELATING TO SUCH INFORMATION IN ANY WAY.
    </p></div> <div className="AMCStaticSection"><h4>INDEMNIFICATION</h4> <p>
      YOU AGREE, TO THE FULLEST EXTENT PERMITTED BY LAW, TO INDEMNIFY AND HOLD
      HARMLESS AUTOMATIC.AI, ITS DIRECTORS, OFFICERS, EMPLOYEES, AFFILIATES,
      AGENTS, CONTRACTORS, PRINCIPALS, AND LICENSORS FROM AND AGAINST ANY
      CLAIMS, DAMAGES, PAYMENTS, DEFICIENCIES, FINES, JUDGMENTS, SETTLEMENTS,
      LIABILITIES, LOSSES, COSTS, AND EXPENSES (INCLUDING REASONABLE
      ATTORNEYS' FEES, COSTS, PENALTIES, INTEREST, AND DISBURSEMENTS) ARISING
      OUT OF OR RELATED TO YOUR BREACH (OR ALLEGED BREACH) OF THESE TERMS AND
      CONDITIONS, THE AUTOMATIC.AI AGREEMENTS AND POLICIES, ANY SERVICE TERMS,
      YOUR DEVELOPMENT AND DEPLOYMENT OF ANY SOFTWARE, YOUR USE OF THE
      SERVICES (OR ANY THIRD PARTY USING YOUR ACCOUNT), INCLUDING THE
      AUTOMATIC.AI API, ANY USER CONSENT OR FEEDBACK, OR THE VIOLATION (OR
      ALLEGED VIOLATION) OF THE RIGHTS OF ANY THIRD PARTY BY YOU OR ANY THIRD
      PARTY USING YOUR ACCOUNT.
    </p></div> <div className="AMCStaticSection"><h4>ARBITRATION</h4> <p>
      PLEASE READ THE FOLLOWING PROVISIONS CAREFULLY BECAUSE THEY REQUIRE YOU
      AND AUTOMATIC.AI TO ARBITRATE DISPUTES AND LIMITS THE MANNER IN WHICH
      BOTH PARTIES CAN SEEK RELIEF.
    </p> <p>
      You and Automatic.ai will arbitrate any dispute, claim, or controversy
      arising from or related to these Terms and Conditions or the Services,
      except that neither you nor Automatic.ai is required to arbitrate any
      dispute in which either party seeks equitable and other relief for the
      alleged unlawful use of copyrights, trademarks, trade names, logos,
      trade secrets, or patents. ARBITRATION PREVENTS YOU AND AUTOMATIC.AI FROM
      SUING IN COURT OR FROM HAVING A JURY TRIAL. You and Automatic.ai will
      notify each other of any dispute within 30 days of when it arises and
      attempt informal resolution before any demand for arbitration.
      Arbitration will be conducted confidentially in Palo Alto, California, by
      a single arbitrator in accordance with the rules of JAMS (or its
      successor). Except as expressly provided in these Terms and Conditions,
      the arbitrator has the authority to grant any remedy that would
      otherwise be available in court. The arbitrator will render a written
      opinion including findings of fact and law, and the award and
      determination of the arbitrator will bind the parties and will not be
      subject to appeal. Judgment may be entered upon the award of the
      arbitrator in any court of competent jurisdiction. The parties will
      equally share the expenses of the arbitration unless the arbitrator
      determines to apportion fees and expenses differently. To the fullest
      extent permitted by Applicable Law, WHETHER THE DISPUTE IS HEARD IN
      ARBITRATION OR IN COURT, NO ARBITRATION OR CLAIM UNDER THESE TERMS AND
      CONDITIONS WILL BE JOINED TO ANY OTHER ARBITRATION OR CLAIM, INCLUDING
      ANY ARBITRATION OR CLAIM INVOLVING ANY OTHER CURRENT OR FORMER USER OF
      THE SERVICES, AND NEITHER YOU NOR AUTOMATIC.AI WILL COMMENCE AGAINST THE
      OTHER A CLASS ACTION, CLASS ARBITRATION, OR OTHER REPRESENTATIVE ACTION
      OR PROCEEDING.
    </p> <p>
      You can choose to reject this agreement to arbitrate ("
      <strong>Opt-out</strong>
      ") by emailing legal@automatic.ai within 30 days after the date you
      agree to these Terms and Conditions for the first time. The Opt-out
      email you send to us must state that you do not agree to this agreement
      to arbitrate and must include your name, address, phone number, and
      email address. Providing an Opt-out notice is the only way you can
      opt-out of this agreement to arbitrate. If you Opt-out of this agreement
      to arbitrate, all other parts of these Terms and Conditions will
      continue to apply.
    </p></div> <div className="AMCStaticSection"><h4>VENUE; GOVERNING LAW</h4> <p>
      The state and federal courts located in Palo Alto, California will
      have exclusive jurisdiction over any suit in connection with the
      Services or these Terms and Conditions that is not subject to
      arbitration, and you and Automatic.ai hereby irrevocably and
      unconditionally consent and submit to the exclusive jurisdiction of such
      courts. These Terms and Conditions and your access to or use of the
      Services will be governed by, construed in accordance with, and enforced
      under the laws of the State of California, without resort to its
      conflict of law provisions.
    </p></div> <div className="AMCStaticSection"><h4>MISCELLANEOUS</h4> <p>
      If any part of these Terms and Conditions is held invalid or
      unenforceable, that portion shall be construed in a manner consistent
      with applicable law to reflect, as nearly as possible, the original
      intentions of the parties, and the remaining portions shall remain in
      full force and effect. Automatic.ai's failure to enforce any right or
      provisions in these Terms and Conditions will not constitute a waiver of
      such or any other provision. Automatic.ai will not be responsible for
      failures to fulfill any obligations due to causes beyond its control.
    </p> <p>
      These Terms and Conditions, and any rights granted in these Terms and
      Conditions, may not be transferred or assigned by you, whether
      voluntarily or by operation of law (including in connection with any
      merger, acquisition, or sale of assets) except with the express written
      consent of Automatic.ai, and any attempted assignment in violation of
      this paragraph is void and of no force or effect. Automatic.ai may
      assign, transfer or delegate any of its rights and obligations hereunder
      without restriction by you. No agency, partnership, joint venture, or
      employment relationship is created as a result of these Terms and
      Conditions and neither party has any authority of any kind to bind the
      other in any respect. Except as otherwise expressly provided elsewhere
      in these Terms and Conditions, there will be no third party
      beneficiaries to these Terms and Conditions. As used in these Terms and
      Conditions, "including" means "including (without limitation)". The
      section headings of these Terms and Conditions are for reference
      purposes only and will not affect the meaning or interpretation of these
      Terms and Conditions.
    </p> <p>
      The Services are operated by Automatic.ai from its offices in the United
      States. You agree to comply with all Applicable Law that relate to your
      use of the Services.
    </p> <p>
      Automatic.ai reserves the right to take steps Automatic.ai believes are
      reasonably necessary or appropriate to enforce and/or verify compliance
      with any part of these Terms and Conditions. You agree that Automatic.ai
      has the right, without liability to you, to disclose any Registration
      Data and/or Account information to law enforcement authorities,
      government officials, and/or a third party, as Automatic.ai believes is
      reasonably necessary or appropriate to enforce and/or verify compliance
      with any part of these Terms and Conditions (including Automatic.ai's
      right to cooperate with any legal process relating to your use of the
      Services and/or a third-party claim that your use of the Services is
      unlawful and/or infringes such third party's rights).
    </p> <p>
      These Terms and Conditions, along with the Automatic.ai Agreements and
      Policies, constitute the entire agreement among the parties with respect
      to the subject matter hereof and supersede and merge all prior
      proposals, understandings, and contemporaneous communications, whether
      oral, written or electronic.
    </p></div> <div><h4>QUESTIONS</h4> <p>
      If you have any questions regarding these Terms and Conditions or your
      use of the Services, please email Automatic.ai at
      <a href="mailto:support@automatic.ai">support@automatic.ai</a>
		<h4>Updated August 27, 2020</h4>
      .
    </p></div></div></div> );
	}
}



// WEBPACK FOOTER //
// ./src/AMCTermsPage.js